import _ from "lodash";
import React, { ReactElement, useRef, useState } from "react";
import { Button } from "react-bootstrap";

import { CSVReader } from "react-papaparse";
import { Lead } from "../Lead";
import { SubmitCSV } from "./SubmitCSV";
import { UploadPreview } from "./UploadPreview";

export const UploadPage = (): ReactElement => {
	const [leads, setLeads] = useState<Lead[] | null>();

	const buttonRef = useRef<any>();

	const handleOpenDialog = (e: any) => {
		if (buttonRef.current) {
			buttonRef.current.open(e);
		}
	};

	const handleOnFileLoad = (data: any) => {
		const leadModels = data.map((d: any) => {
			// Todo: In the future it would be better
			// to have and interface to do this, currently
			// this is mainly to accomodate the zoom info spreadsheets.
			const mappings: any = {
				"Company Name": "company",
				"First Name": "firstname",
				"Last Name": "lastname",
				Title: "title",
				"Direct Phone Number": "phone",
				"Email Address": "email",
				Website: "website",
				"Company HQ Phone": "phone_other_c",
				Employees: "numberofemployees",
				"Company Street Address": "street",
				"Company City": "city",
				"Company State": "state",
				"Company Zip Code": "postalcode",
				"Company Country": "country",
			};

			for (const [key, value] of Object.entries(d.data)) {
				if (key in mappings) {
					d.data[mappings[key]] = value;
				}
			}

			return Lead.fromJson(d.data);
		});

		setLeads(leadModels);
	};

	return (
		<div className="container mb-3" id="csv-upload">
			<h1 className="mb-4">Upload CSV</h1>

			{leads ? (
				<>
					<Button
						className="pull-right"
						onClick={() => setLeads(null)}
					>
						Cancel
					</Button>
					<p>
						Listed below are the leads that will be uploaded. Only
						leads with a green checkmark will be uploaded, other
						leads already exist in the system.
					</p>
					<UploadPreview leads={leads} />
					<SubmitCSV leads={leads} />
				</>
			) : (
				<CSVReader
					ref={buttonRef}
					onFileLoad={handleOnFileLoad}
					noDrag
					config={{ header: true }}
				>
					<button type="button" onClick={handleOpenDialog}>
						Browse file
					</button>
				</CSVReader>
			)}
		</div>
	);
};
